module.exports = __webpack_public_path__ + "static/media/satisfied-feedback-chosen.7d5988be.png";